module.exports = __webpack_public_path__ + "images/1443ce5fe4ce2b63b8826c7ab5309b23.png";